// extracted by mini-css-extract-plugin
export default {"table":"TalentInfoTable_table__HPd8C","title":"TalentInfoTable_title__hwfii"};